import { useNavigate } from 'react-router-dom';
import { useSetupStore } from '../store/setupStore';
import CategorySelectionStep from '../components/setup/CategorySelectionStep';
import ClassFrequencyStep from '../components/setup/ClassFrequencyStep';
import FeedbackTypeStep from '../components/setup/FeedbackTypeStep';
import ReviewStep from '../components/setup/ReviewStep';
import { ClassNavigation } from '../components/layout';

const SetupWizard = () => {
  const navigate = useNavigate();
  const { currentStep, setCurrentStep, setup } = useSetupStore();

  const steps = [
    { title: 'Class Frequency', component: ClassFrequencyStep },
    { title: 'Select Categories', component: CategorySelectionStep },
    { title: 'Feedback Type', component: FeedbackTypeStep },
    { title: 'Review', component: ReviewStep },
  ];

  const CurrentStepComponent = steps[currentStep].component;

  const handleNext = () => {
    if (currentStep === steps.length - 1) {
      // On the last step (Review)
      navigate(-1); // Go back to the previous page
    } else {
      // Validate current step before proceeding
      let canProceed = true;

      switch (currentStep) {
        case 0: // Class Frequency
          canProceed = setup.totalClasses > 0;
          if (!canProceed) {
            alert('Please enter the total number of classes');
          }
          break;
        case 1: // Category Selection
          canProceed = setup.selectedCategories.some(cat => cat.selected);
          if (!canProceed) {
            alert('Please select at least one category');
          }
          break;
        case 2: // Feedback Type
          canProceed = setup.questionsPerSession > 0;
          if (!canProceed) {
            alert('Please set the number of questions per session');
          }
          break;
        default:
          canProceed = true;
      }

      if (canProceed) {
        setCurrentStep(currentStep + 1);
      }
    }
  };

  const handlePrevious = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  return (
    <div>
      <ClassNavigation />
      
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Setup Class Feedback</h1>
        <div className="flex justify-between items-center">
          {steps.map((step, index) => (
            <div
              key={step.title}
              className={`flex items-center ${
                index < steps.length - 1 ? 'flex-1' : ''
              }`}
            >
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center ${
                  index <= currentStep
                    ? 'bg-emerald-600 text-white'
                    : 'bg-gray-200 text-gray-600'
                }`}
              >
                {index + 1}
              </div>
              {index < steps.length - 1 && (
                <div
                  className={`flex-1 h-1 mx-2 ${
                    index < currentStep ? 'bg-emerald-600' : 'bg-gray-200'
                  }`}
                />
              )}
            </div>
          ))}
        </div>
      </div>
      <CurrentStepComponent />
      <div className="mt-8 flex justify-between">
        <button
          onClick={handlePrevious}
          disabled={currentStep === 0}
          className={`px-4 py-2 rounded ${
            currentStep === 0
              ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
              : 'bg-gray-500 text-white hover:bg-gray-600 transition-colors'
          }`}
          type="button"
        >
          Previous
        </button>
        <button
          onClick={handleNext}
          className="px-4 py-2 bg-emerald-600 text-white rounded hover:bg-emerald-700 transition-colors shadow-sm hover:shadow-md"
          type="button"
        >
          {currentStep === steps.length - 1 ? 'Finish' : 'Next'}
        </button>
      </div>
      </div>
    </div>
  );
};

export default SetupWizard;